import React, { useState } from "react";
import { NavBar as DSNav } from "widgets/NavBar";
import { NotificationDotType } from "widgets/NavBar/NotificationDot";
import { NAV_MENU_V3_ENGAGEMENTS } from "./constants";
import { recordPatientAppClickEngagement } from "../../utils/engagements";

export interface MyAccountMenuMobileProps {
    notificationCenterUrl: string;
    insuranceUrl: string | null;
    insuranceConsentUrl: string | null;
    notifyAboutInvalidOrMissingContactInfo: boolean;
}

export const MyAccountMenuMobile = ({
    notificationCenterUrl,
    insuranceUrl,
    insuranceConsentUrl,
    notifyAboutInvalidOrMissingContactInfo,
}: MyAccountMenuMobileProps) => {
    const [submenuOpen, setSubmenuOpen] = useState(false);
    const onOpenClose = (open: boolean) => {
        setSubmenuOpen(open);
    };

    return (
        <DSNav.Menu className="s768:hidden" onOpenClose={onOpenClose}>
            <DSNav.MenuButton
                onClick={() =>
                    recordPatientAppClickEngagement(NAV_MENU_V3_ENGAGEMENTS.MY_ACCOUNT_DROPDOWN_BTN)
                }
            >
                <div className="flex items-center">
                    {gettext("My account")}
                    {notifyAboutInvalidOrMissingContactInfo && !submenuOpen && (
                        <DSNav.NotificationDot
                            id="menu-closed-mobile-invalid-or-missing-contact-dot"
                            type={NotificationDotType.MENU_ITEM}
                        />
                    )}
                </div>
            </DSNav.MenuButton>
            <DSNav.MenuItems>
                <DSNav.MenuItem
                    href={notificationCenterUrl}
                    onClick={() =>
                        recordPatientAppClickEngagement(NAV_MENU_V3_ENGAGEMENTS.MY_ACCOUNT_BTN)
                    }
                >
                    <div className="flex items-center">
                        {gettext("My account")}
                        {notifyAboutInvalidOrMissingContactInfo && submenuOpen && (
                            <DSNav.NotificationDot
                                id="menu-open-mobile-invalid-or-missing-contact-dot"
                                type={NotificationDotType.MENU_ITEM}
                            />
                        )}
                    </div>
                </DSNav.MenuItem>
                {insuranceUrl && (
                    <DSNav.MenuItem
                        href={insuranceUrl}
                        onClick={() =>
                            recordPatientAppClickEngagement(
                                NAV_MENU_V3_ENGAGEMENTS.ADD_INSURANCE_BTN,
                            )
                        }
                    >
                        {gettext("Add insurance")}
                    </DSNav.MenuItem>
                )}
                {insuranceConsentUrl && (
                    <DSNav.MenuItem
                        href={insuranceConsentUrl}
                        onClick={() =>
                            recordPatientAppClickEngagement(
                                NAV_MENU_V3_ENGAGEMENTS.ADD_INSURANCE_APPROVAL_BTN,
                            )
                        }
                    >
                        {gettext("Add insurance approval")}
                    </DSNav.MenuItem>
                )}
            </DSNav.MenuItems>
        </DSNav.Menu>
    );
};
